import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdavb5z6k8: FaireProductEntity = {
  token: "p_gdavb5z6k8",
  type: "product",
  name: "FLORAL CHILD OF GOD CASUAL BASEBALL CAP | 40HW742",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/01ab202a91d7caf11fd622cb4ba36a536fb21fc20f7b1f104dfb2a0830836bf5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87232736d829db0c0a289897b5d97f347e3a9fe5ef0f1fc9226cf4dffdf45a89.jpeg",
    "https://cdn.faire.com/fastly/e6a0b67cd01a697c7c8434b2e12925d496aa1a13ca703302dcb9a1c3cf38f4f9.jpeg",
    "https://cdn.faire.com/fastly/0d95c6d0a5048aa1346c8b7343aa0ac3c47fdf31e089c6d5d9e61dca106993dd.jpeg",
  ],
  priceDollars: 5.95,
  description:
    'The Floral with Child of God wording on a Casual Baseball Cap effortlessly merges fashion and comfort, making it an essential part of your casual wardrobe. It has great fit-One size with adjustable  strap. Easy to wear comfortably with a ponytail or messy bun. Great Quality-premium washed caps. Lightweight super soft finish. Exceptional quality.\n\nDIMENSION:\nHeight: 4.75"\nBrim: center 2.75"  \nCircumference: 22"\nMaterial: 100% cotton',
  tags: [],
  msrpDollars: 11.9,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:50.020Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
